var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import Store from '../../stores/store';
import CustomLoader from '../CommonComponents/CustomLoader';
var classes = {
    loaderRoot: function (theme) { return ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }); },
};
var ShopifyExpanded = /** @class */ (function (_super) {
    __extends(ShopifyExpanded, _super);
    function ShopifyExpanded(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAddToCart = function (e, variant) { return __awaiter(_this, void 0, void 0, function () {
            var _a, addToShopifyCart, djangoPk;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, addToShopifyCart = _a.addToShopifyCart, djangoPk = _a.djangoPk;
                        e.preventDefault();
                        this.setState({ addingToCart: true, variant: variant });
                        return [4 /*yield*/, addToShopifyCart(variant, 1, djangoPk)];
                    case 1:
                        _b.sent();
                        this.setState({ addingToCart: false });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            variants: [],
            isForSale: false,
            addingToCart: false,
            variant: { id: '', fulfillmentService: '' },
        };
        return _this;
    }
    ShopifyExpanded.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (!isEqual(this.props, nextProps)) {
            if (!isEmpty(nextProps.shopifyVariants)) {
                this.setState({
                    isForSale: true,
                    variants: nextProps.shopifyVariants,
                });
            }
            else {
                this.setState({
                    isForSale: false,
                    variants: [],
                });
            }
        }
    };
    ShopifyExpanded.prototype.render = function () {
        var _this = this;
        var variantElemtns = [];
        var _a = this.state, variants = _a.variants, isForSale = _a.isForSale, addingToCart = _a.addingToCart, variant = _a.variant;
        var plantName = this.props.plantName;
        var result = null;
        variants.forEach(function (item) {
            if (Store.isNursery) {
                if (item.available && item.fulfillment_service === Store.nurserySlug) {
                    var shippingInfo = 'Shipping based on size & location';
                    if (item.nursery) {
                        shippingInfo = item.nursery.shipping_info;
                    }
                    variantElemtns.push(React.createElement("div", { className: "shopify_buy_outer", key: item.id },
                        React.createElement("div", { className: "shopify_buy_inner" },
                            React.createElement("h3", null,
                                item.title,
                                ' ',
                                "|",
                                ' ',
                                React.createElement("span", null,
                                    "$",
                                    item.price)),
                            React.createElement("p", null, shippingInfo),
                            React.createElement("button", { className: "btn primary", type: "button", onClick: function (e) {
                                    _this.handleAddToCart(e, { id: item.id });
                                }, disabled: addingToCart },
                                addingToCart && item.id === variant.id && (React.createElement(CustomLoader, { loaderClassName: classes.loaderRoot, loaderAttributes: { size: 20, thickness: 5 } })),
                                "Add to Cart"))));
                }
            }
            else if (item.available) {
                var shippingInfo = 'Shipping based on size & location';
                if (item.nursery) {
                    shippingInfo = item.nursery.shipping_info;
                }
                variantElemtns.push(React.createElement("div", { className: "shopify_buy_outer", key: item.id },
                    React.createElement("div", { className: "shopify_buy_inner" },
                        React.createElement("h3", null,
                            item.title,
                            ' ',
                            "|",
                            ' ',
                            React.createElement("span", null,
                                "$",
                                item.price)),
                        React.createElement("p", null, shippingInfo),
                        React.createElement("button", { className: "btn primary", type: "button", onClick: function (e) {
                                _this.handleAddToCart(e, { id: item.id });
                            }, disabled: addingToCart },
                            addingToCart && item.id === variant.id && (React.createElement(CustomLoader, { loaderClassName: classes.loaderRoot, loaderAttributes: { size: 20, thickness: 5 } })),
                            "Add to Cart"))));
            }
        });
        if (isForSale) {
            result = (React.createElement("div", { className: "buy_expanded" },
                React.createElement("h2", null, "Order ".concat(plantName, " Today")),
                React.createElement("p", { className: "subtitle" },
                    React.createElement("span", null, "TIP"),
                    ": Shipping price doesn't rise much as you add more plants to the same box. The best economy comes from placing a larger order. We humbly suggest that plants look great planted in groups of three."),
                React.createElement("div", { className: "buy_expanded_grid" }, variantElemtns)));
        }
        return result;
    };
    ShopifyExpanded = __decorate([
        observer
    ], ShopifyExpanded);
    return ShopifyExpanded;
}(React.Component));
export default ShopifyExpanded;
